import { Tab } from '@scuf/common';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RmaAdminChat, RmaReport, RmaSearch, RmaSummary } from './components';
import ManageEOSmodels from './components/tabs/manageEOSmodels';
import useUser from 'helpers/hooks/useUser';
import { UserRole } from 'models/user/sso';
import { RmaChatTable } from 'models/repaircenter/detailsRma';
import { ChatRma, REPAIR_CENTER, USER_MANAGER } from 'resources';
import useFetch from 'helpers/hooks/useFetch';
import { useRecoilState } from 'recoil';
import ServiceOrders from './components/tabs/serviceOrders';
import RmaDistribution from './components/tabs/rmaDistribution';
import RmaCoupons from './components/tabs/rmaCoupons';

interface ManualFile {
    id: number;
    displayName: string;
    storedFileName: string;
    section: 'REPAIRCENTER';
}

function RepairCenter() {
    const [width, setWidth] = useState<number>(0);
    var [numResult, setNumResult] = useState<any>([]);
    const { user } = useUser();
    const { t } = useTranslation(['repaircenter', 'common', 'pages']);
    const [chatsRma, setChatsRmas] = useRecoilState<RmaChatTable[]>(ChatRma);
    const [unreadMessage, setUnreadMessage] = useState<number>(0);
    const [chats, loadChats, loading, updateChat] = useFetch<
        { roleId: number; ssoId: string; companyId: number },
        RmaChatTable[]
    >({
        url: REPAIR_CENTER.getAllChats
    });

    const [show, setShow] = useState(false);
    const { user: userDetails, getUser } = useUser();
    const [fileUrl, setFileUrl] = useState<string>();
    const [, fetchFiles] = useFetch<void, ManualFile[]>({
        url: `${USER_MANAGER.getManualFilesBySection}?section=REPAIRCENTER`,
        method: 'GET'
    });

    useEffect(() => {
        if (userDetails && Object.keys(userDetails).length > 0) {
            loadFiles();
        }
    }, [userDetails]);

    const loadFiles = async (): Promise<void> => {
        try {
            await fetchFiles(undefined, resp => {
                const checkList: ManualFile[] = resp?.data ?? [];
                if (checkList.length > 0) {
                    const foundFile = checkList.find(file => file.displayName === 'mensagemrepair');
                    if (foundFile) {
                        const url = `${USER_MANAGER.downloadManualFileById}?id=${foundFile.id}`;
                        setFileUrl(url);
                        setShow(true);
                    }
                }
            });
        } catch (error: any) {
            if (error.status === 401) {
                await getUser();
            } else {
                console.error(t('manual.fetchFilesError'));
            }
        }
    };

    function handleResize() {
        setNumResult(10);
        setWidth(window.innerWidth);
    }
    const UnreadMessage = () => {
        chats?.data?.forEach(e => {
            if (user?.role === '1' || user?.role === '2') {
                if (e.itWasReadByAdmin === false) {
                    setUnreadMessage(unreadMessage => unreadMessage + 1);
                }
            } else if (user?.role === '3' || user?.role === '4') {
                if (e.itWasReadByCustomer === false) {
                    setUnreadMessage(messageRead => messageRead + 1);
                }
            }
        });
    };
    useEffect(() => {
        UnreadMessage();
        setChatsRmas(chats?.data?.map((e: RmaChatTable) => ({ ...e }))!);
    }, [chats]);

    useEffect(() => {
        loadChats({ roleId: parseInt(user?.role!), ssoId: user?.ssoid!, companyId: user?.company! });
        setWidth(window.innerWidth);

        UnreadMessage();
        window.addEventListener('resize', handleResize);
    }, []);

    return (
        <>
            {show && userDetails && Object.keys(userDetails).length > 0 && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        width: '100vw',
                        height: '100vh',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999
                    }}
                    onClick={() => setShow(false)}
                >
                    <img
                        style={{ maxWidth: '800px', maxHeight: '800px' }}
                        src={fileUrl}
                        onClick={e => e.stopPropagation()}
                        title="Mensagem Portal"
                    />
                </div>
            )}
            <div className="container wrap-content">
                <Tab defaultActiveIndex={0} className="tab-with-divider">
                    <Tab.Pane title={t('RMA')}>
                        <RmaSearch />
                    </Tab.Pane>
                    <Tab.Pane title={t('Consulta Serial')}>
                        <RmaSummary />
                    </Tab.Pane>
                    <Tab.Pane title={t('common:translation.Report')}>
                        <RmaReport />
                    </Tab.Pane>
                    {[UserRole.ADMIN, UserRole.SUPERADMIN].includes(user?.role!)
                        ? [<Tab.Pane title={t('manage_eos.Name')}>{<ManageEOSmodels />}</Tab.Pane>]
                        : []}
                    <Tab.Pane title={t('common:tabs.Chat')} badge={unreadMessage} color="red">
                        <RmaAdminChat />
                    </Tab.Pane>
                    <Tab.Pane title={t('repaircenter:translation.ApproveBudget')}>
                        <ServiceOrders />
                    </Tab.Pane>
                    {[UserRole.ADMIN, UserRole.SUPERADMIN].includes(user?.role!)
                        ? [<Tab.Pane title={t('common:translation.Distribution')}>{<RmaDistribution />}</Tab.Pane>]
                        : []}
                    {[UserRole.ADMIN, UserRole.SUPERADMIN].includes(user?.role!)
                        ? [<Tab.Pane title={t('pages:Coupons')}>{<RmaCoupons />}</Tab.Pane>]
                        : []}
                </Tab>
            </div>
        </>
    );
}

export default RepairCenter;
